import React, { Component } from 'react';
import WalletTransactionForm from './WalletTransactionForm';

// Populated at container startup from SIGNATURE/PARENT_WINDOW_LOCATION env vars (see nginx/docker-entrypoint.sh).
// public/env-config.js provides local-dev defaults when running via `npm start`.
const signature = window.__ENV__.SIGNATURE;
const parentWindowLocation = window.__ENV__.PARENT_WINDOW_LOCATION;

class App extends Component {

	_isMounted = false;

	constructor() {
		super();
		// When embedded on the Contact data page, CRM.COM appends the contact id as the last URL segment
		let url = window.location.href.split("/");
		let contactId = url[url.length - 1];
		this.state = {
			accessToken: null,
			contactId: contactId,
		};
		window.onmessage = this.messageHandler;
	}

	componentDidMount() {
		this._isMounted = true;
		let message = {
			signature: signature,
			message: "AUTH",
		};
		this.messageSender(JSON.stringify(message));
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	messageHandler = (event) => {
		if (event.origin !== parentWindowLocation) {
			return;
		} else if (typeof event.data === 'string') {
			let data = JSON.parse(event.data);
			if (data.access_token) {
				this._isMounted && this.setState({
					accessToken: data.access_token
				});
			}
		}
	}

	messageSender = (message) => {
		if (window.top) {
			window.top.postMessage(message, parentWindowLocation);
		}
	}

	render() {
		return (
			<WalletTransactionForm
				accessToken={this.state.accessToken}
				contactId={this.state.contactId}
				signature={signature}
				messageSender={this.messageSender}
			/>
		);
	}
}

export default App;
